<div class="divHome">
  <h1>Reporte de Costos</h1>

  <div *ngIf="loading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading" style="display: flex; justify-content: center">
    <mat-form-field appearance="outline" class="divInputSearch">
      <mat-label>Filtrar</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Filtrar Búsqueda"
      />
    </mat-form-field>
  </div>

  <div *ngIf="!loading" style="display: flex; justify-content: space-between">
    <div
      class="divButtons"
      style="justify-content: flex-start; margin-bottom: 1rem"
    >
      <mat-form-field appearance="fill" class="buttonFilterFecha">
        <mat-label>FECHA OPERACIÓN</mat-label>

        <mat-datepicker-toggle
          matSuffix
          [for]="rangePicker"
        ></mat-datepicker-toggle>

        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
          <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
        </mat-date-range-input>

        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button
              style="background-color: rgb(184, 69, 18); color: white"
              mat-raised-button
              (click)="applyFilterSelect()"
              matDateRangePickerApply
            >
              Filtrar
            </button>

            <button
              mat-button
              matDateRangePickerCancel
              (click)="cleanDateSelected()"
            >
              Limpiar
            </button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </div>

    <!--  <button mat-raised-button class="buttonPrimary" style="height: 50%;width: 13rem;" (click)="generarOrdenSalida()">Generar Orden de Salida</button> -->
  </div>

  <div *ngIf="!loading" class="mat-elevation-z8 overflow">
    <table mat-table [dataSource]="dataSource" style="margin-top: 0.4%">
      <ng-container matColumnDef="fileNumber">
        <th mat-header-cell *matHeaderCellDef>FILE</th>
        <td mat-cell *matCellDef="let element">{{ element?.fileNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
        <td mat-cell *matCellDef="let element">{{ element?.fileName }}</td>
      </ng-container>

      <ng-container matColumnDef="dateRange">
        <th mat-header-cell *matHeaderCellDef>FECHA OPERACIÓN</th>
        <td mat-cell *matCellDef="let element">{{ element?.dateRange }}</td>
      </ng-container>

      <ng-container matColumnDef="costo">
        <th mat-header-cell *matHeaderCellDef>COSTO</th>
        <td mat-cell *matCellDef="let element">
          S/{{ element?.costo.toFixed(2) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <div [hidden]="loading">
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
